// 鍔ㄦ€佸紩鍏ユ墍鏈夌粍浠 js
let req = require.context('./', true, /\.js$/i)
req.keys(req).map(req)
